define([], function () {

    return ['StateUtils', (stateUtils) => {

        const service = {
            createUniqueID: () => {
                //https://www.w3resource.com/javascript-exercises/javascript-math-exercise-23.php
                let dt = new Date().getTime();
                return 'xxxx4xxxyx'.replace(/[xy]/g, function (c) {
                    let r = (dt + Math.random() * 16) % 16 | 0;
                    dt = Math.floor(dt / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
            },
            generatedCIDString() {
                const activeDataForState = stateUtils && stateUtils.activeDataForState(true);
                const submission = activeDataForState && activeDataForState.model ? activeDataForState.model.value : null;
                const quoteId = submission ? submission.quoteID : null;
                const sessionId = submission ? submission.sessionUUID : null;
                return `QID: ${quoteId ? quoteId : '-'}|SID: ${sessionId ? sessionId : '-'}|requestID: ${(this.createUniqueID())}`;
            }
        };
        return service;
    }];

});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/transport/TransportUtil.js